export default "__VITE_ASSET__DGMObhGq__"